import { render, staticRenderFns } from "./submitOutcome.vue?vue&type=template&id=6f9d6d28&scoped=true"
import script from "./submitOutcome.vue?vue&type=script&lang=js"
export * from "./submitOutcome.vue?vue&type=script&lang=js"
import style0 from "./submitOutcome.vue?vue&type=style&index=0&id=6f9d6d28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9d6d28",
  null
  
)

export default component.exports